export const USER_APIKEY = "userApiKey"
export const USER_DATA = "userData"